import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './NoticeDetail.module.css';
import parse from 'html-react-parser';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';

export default function NoticeDetail() {
  const { noticeId } = useParams();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/notice/${noticeId}`);
        if (response.data.code === 1) {
          setNotice(response.data.data);
        } else {
          setError('공지사항을 찾을 수 없습니다.');
        }
      } catch (error) {
        console.error('공지사항 조회 오류: ', error);
        setError('공지사항을 불러오는 중 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchNotice();
  }, [noticeId]);

  const handleDelete = async () => {
    const confirmed = window.confirm('정말로 이 공지사항을 삭제하시겠습니까?');
    if (confirmed) {
      try {
        // Mock API 호출 (실제 환경에서는 실제 API로 변경)
        const response = await axios.delete(`${API_BASE_URL}/api/v1/admin/notice/${noticeId}`);
        if (response.data.code === 1) {
          alert('삭제 되었습니다.');
          // 삭제 후 목록 페이지로 이동
          navigate('/notices');
        } else {
          alert('삭제 실패: 서버 응답 오류류')
        }
      } catch (error) {
        console.error('공지사항 삭제 오류:', error);
        alert('공지사항 삭제 중 오류가 발생했습니다.');
      }
    }
  };

  const handleEdit = () => {
    navigate(`/notices/${noticeId}/edit`);
  };

  const handleBack = () => {
    navigate('/notices');
  };

  // MySQL TIMESTAMP 형식 날짜 포매팅
  // const formatDate = (dateString) => {
  //   if (!dateString) return '';

  //   try {
  //     const date = new Date(dateString);
  //     return date.toISOString().split('T')[0]; // 'YYYY-MM-DD' 형식으로 반환
  //   } catch (error) {
  //     console.error('날짜 형식 오류:', error);
  //     return dateString;
  //   }
  // };
  const formatDate = (dateString) => {
    if (!dateString) return '';
  
    try {
      const localDate = new Date(dateString); // UTC로 해석되어 9시간 차이 발생
      // KST 보정 (UTC+9)
      localDate.setHours(localDate.getHours() + 9);
      return localDate.toISOString().split('T')[0];
    } catch (error) {
      console.error('날짜 형식 오류:', error);
      return dateString;
    }
  };
  

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingWrapper}>
          <div className={styles.loading}>로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <div className={styles.error}>{error}</div>
          <button onClick={handleBack} className={styles.backButton}>
            목록으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  if (!notice) {
    return (
      <div className={styles.container}>
        <div className={styles.errorWrapper}>
          <div className={styles.error}>공지사항을 찾을 수 없습니다.</div>
          <button onClick={handleBack} className={styles.backButton}>
            목록으로 돌아가기
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.actions}>
          <button onClick={handleBack} className={styles.actionButton}>
            목록
          </button>
        </div>
        
        {/* DB 스키마에 맞춘 필드명 사용 */}
        <h1 className={styles.title}>{notice.title}</h1>
        
        <div className={styles.meta}>
          <span className={styles.date}>등록일: {formatDate(notice.createdAt)}</span>
          {notice.updated_at && notice.updated_at !== notice.created_at && (
            <span className={styles.date}>수정일: {formatDate(notice.updatedAt)}</span>
          )}
        </div>
      </div>

      {/* HTML 파싱하여 내용 표시 */}
      <div className={styles.content}>
        {parse(notice.content)}
      </div>

      <div className={styles.rightActions}>
        <button onClick={handleDelete} className={styles.deleteButton}>
          삭제
        </button>
        <button onClick={handleEdit} className={styles.editButton}>
          수정
        </button>
      </div>
    </div>
  );
}